export const errorMessages = {
  errorCodes: {
    password: {
      pattern: 'password-pattern-field',
      notMatch: 'password-not-matched-field',
    },
    confirmPassword: {
      pattern: 'password-pattern-field',
      notMatch: 'password-not-matched-field',
    },
    agreeConfirmation: {
      pattern: 'confirmation-pattern-field',
    },
    emailAddress: {
      pattern: 'default-email-field',
    },
    default: {
      required: 'default-required-field',
      minlength: 'default-minlength-field',
      maxlength: 'default-maxlength-field',
      email: 'default-email-field',
      validation: 'default-validation-field',
      pattern: 'default-pattern-validation',
      notMatch: 'default-not-matched-field',
      min: 'default-min-value',
      max: 'default-max-value',
    },
  },
};
